import type { Theme } from '../../design-system/providers/appearance';

/**
 * Which wordmark file a theme gets.
 *
 * `logo.png` bakes in a near-black wordmark and `logo_light.png` a white one,
 * so neither works on both grounds — this is one asset with two colourways,
 * not one asset plus a filter. A CSS `invert()` was rejected for the same
 * reason it was rejected when the logo first landed: it would also invert the
 * butterfly mark's yellow, and that is a third-party brand mark, not ours to
 * recolour.
 *
 * Swapping the FILE is what let the light plate behind the mark go away. The
 * plate existed only because a dark-on-dark wordmark needed a light card under
 * it; with a colourway per theme there is nothing to compensate for.
 *
 * Exported as a function rather than inlined at each call site because there
 * are two — the sidebar and the login card — and a second copy is a second
 * thing to remember when a third appears.
 */
export function brandLogoSrc(theme: Theme): string {
  return theme === 'light' ? '/logo.png' : '/logo_light.png';
}
